import { useTranslations } from 'next-intl';
import { ComponentProps } from 'react';
import { Text } from '@/lib/ui-kit/text';
import { cn } from '@/lib/ui-kit/utils';

type EmptyBidsProps = ComponentProps<'div'>;

export const EmptyBids = ({ className, ...props }: EmptyBidsProps) => {
  const t = useTranslations('orderBook');

  return (
    <div
      className={cn(
        `flex h-9 w-full shrink-0 flex-row items-center justify-center gap-2 px-3 text-v2-text-secondary
        md:px-4`,
        className,
      )}
      {...props}
    >
      <Text variant="label-md">{t('noBids')}</Text>
    </div>
  );
};
